import '@pixi-spine/loader-base';
import { SpineLoader } from './SpineLoader.mjs';
export { Spine } from './Spine.mjs';
export { SPINE_VERSION, detectSpineVersion } from './versions.mjs';

new SpineLoader().installLoader();
//# sourceMappingURL=index.mjs.map
